const ARIA_INVALID = 'aria-invalid';
export const handleError = (control, errorMessage) => {
    const beaconFormField = control.parentElement;
    let slottedError = beaconFormField.querySelector('[slot="error"]');
    if (!slottedError) {
        const errorContainer = document.createElement('div');
        errorContainer.slot = 'error';
        beaconFormField?.append(errorContainer);
        slottedError = errorContainer;
    }
    slottedError.innerText = errorMessage;
    control.setAttribute(ARIA_INVALID, 'true');
};

export const removeError = (control) => {
    const beaconFormField = control.parentElement;
    const slottedError = beaconFormField.querySelector('[slot="error"]');
    if (slottedError) {
        slottedError.remove();
    }
    control.setAttribute(ARIA_INVALID, 'false');
}

export const getErrorType = (validity) => {
    const { valueMissing, tooShort, tooLong, patternMismatch, rangeOverflow } = validity;
    if (valueMissing) {
        return 'required';
    }
    if (tooShort || tooLong || patternMismatch || rangeOverflow) {
        return 'invalid';
    }
    return null;
};

export const getErrorMessage = (controlId, errorType, errorMap, defaultMessage) => {
    for (const key in errorMap) {
        const regex = new RegExp(`^${key}`);
        if (regex.test(controlId)) {
            return errorMap[key][errorType] || defaultMessage;
        }
    }
    return defaultMessage;
};

export const validateControl = (control, errorMessages) => {
    const validity = control.validity;
    const errorType = getErrorType(validity);
    const errorMap = {
        'first-name': { required: errorMessages.FIRST_NAME_REQUIRED, invalid: errorMessages.INVALID_FIRST_NAME },
        'last-name': { required: errorMessages.LAST_NAME_REQUIRED, invalid: errorMessages.INVALID_LAST_NAME },
        'date-picker': { required: errorMessages.DATE_OF_BIRTHDAY, invalid: errorMessages.INVALID_DATE_OF_BIRTH },
        'gva-taxId': { required: errorMessages.SOCIAL_SECURITY_NUMBER, invalid: errorMessages.INVALID_SOCIAL_SECURITY_NUMBER }
    };

    if (errorType) {
        const errorMessage = getErrorMessage(control.id, errorType, errorMap);
        handleError(control, errorMessage);
    } else {
        removeError(control);
    }
};

export const processControl = (control, errorMessages) => {
    if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) {
        return;
    }

    try {
        control.checkValidity();
        validateControl(control, errorMessages);
    } catch (error) {
        console.error(error, control);
    }
};

export const handleGVAFormSubmit = (form, errorMessages) => {
    if (!(form instanceof HTMLFormElement || form instanceof HTMLSelectElement)) {
        return [];
    }

    const { elements } = form;

    Array.from(elements).forEach((control) => {
        processControl(control, errorMessages);
    });
};
